import { ReduxUtils } from '../../../dependencies';
import types from '../../actionTypes';

const actionTypes = {
    REQUEST: types.DELETE_TAG_REQUEST,
    SUCCESS: types.DELETE_TAG_SUCCESS,
    FAILURE: types.DELETE_TAG_FAILURE,
    CANCEL: types.DELETE_TAG_CANCEL,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
